import { Pivot, PivotItem, IPivotStyles } from "@fluentui/react";
import { PropsWithChildren, useCallback, useState } from "react";

export const TabsContainer = ({
  ariaLabel,
  children,
  handleSelectedTab,
  styles,
  selectedKey: externalSelectedKey,
  overflowBehavior = "menu"
}: PropsWithChildren<{
  ariaLabel?: string;
  handleSelectedTab?: (item?: PivotItem) => void;
  styles?: Partial<IPivotStyles>;
  selectedKey?: string;
  overflowBehavior?: "none" | "menu";
}>) => {
  const [internalSelectedTab, setInternalSelectedTab] = useState("");

  // Use external selectedKey if provided, otherwise use internal state
  const selectedTab = externalSelectedKey ?? internalSelectedTab;

  const handleLinkClick = useCallback(
    (item?: PivotItem) => {
      const selectedTabKey = item?.props.itemKey as string;

      if (handleSelectedTab) {
        handleSelectedTab(item);
      }

      // Only update internal state if no external selectedKey is provided
      if (externalSelectedKey === undefined) {
        setInternalSelectedTab(selectedTabKey);
      }
    },
    [handleSelectedTab, externalSelectedKey]
  );

  return (
    <Pivot
      aria-label={ariaLabel}
      selectedKey={selectedTab}
      styles={styles}
      onLinkClick={handleLinkClick}
      overflowBehavior={overflowBehavior}
    >
      {children}
    </Pivot>
  );
};
